/**
 * Blocks direct access to Manage Plan (subscription) routes when the feature is temporarily disabled.
 * Redirects to the dashboard with a query flag so the dashboard can show a snackbar once.
 */

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FeatureFlags, RoutePaths } from '../constants';

export const managePlanPageGuard: CanActivateFn = () => {
  if (FeatureFlags.MANAGE_PLAN_PAGE_ENABLED) {
    return true;
  }
  const router = inject(Router);
  return router.createUrlTree([RoutePaths.DASHBOARD], {
    queryParams: { managePlanSoon: '1' }
  });
};
